<template>
  <div>
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        <IconMoreOptionComponent size="small" theme="blue" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <!-- 1. Ver -->
        <el-dropdown-item command="liquidation-view">
          <i class="el-icon-view"></i> Ver
        </el-dropdown-item>

        <!-- 2. Enviar documento -->
        <el-dropdown-item command="liquidation-send">
          <i class="el-icon-s-promotion"></i> Enviar documento
        </el-dropdown-item>

        <!-- Firmar / Re-intentar firma -->
        <template
          v-if="
            status === 'draft' || status === 'failed' || status === 'timeout'
          "
        >
          <el-dropdown-item command="liquidation-signature">
            <i class="el-icon-edit-outline"></i>
            {{ status === "timeout" ? "Re-intentar firma" : "Firmar" }}
          </el-dropdown-item>
        </template>

        <!-- Editar -->
        <template v-if="status === 'draft' || status === 'failed'">
          <el-dropdown-item command="liquidation-edit">
            <i class="el-icon-edit"></i> Editar
          </el-dropdown-item>
        </template>

        <!-- Descargar PDF -->
        <el-dropdown-item command="liquidation-download">
          <i class="el-icon-download"></i> Descargar PDF
        </el-dropdown-item>

        <!-- Marcar / Desmarcar como pagada -->
        <el-dropdown-item command="liquidation-paid">
          <i class="el-icon-circle-check"></i> {{ textOptionIsPaid }} como
          pagada
        </el-dropdown-item>

        <!-- Anular -->
        <template v-if="status === 'success'">
          <el-dropdown-item command="liquidation-nuled">
            <i class="el-icon-circle-close"></i> Anular liquidación
          </el-dropdown-item>
        </template>

        <!-- Eliminar (siempre al final) -->
        <template
          v-if="
            status === 'draft' || status === 'failed' || status === 'timeout'
          "
        >
          <el-dropdown-item command="liquidation-delete" divided>
            <i class="el-icon-delete"></i> Eliminar
          </el-dropdown-item>
        </template>
      </el-dropdown-menu>
    </el-dropdown>

    <SigningConfirmModal
      :visible.sync="sriModalVisible"
      :documentNumber="liquidation ? liquidation.number_liquidation : ''"
      :clientName="
        liquidation && liquidation.client ? liquidation.client.name : ''
      "
      :amount="liquidation ? liquidation.total : 0"
      @confirm="sendSRI"
    />

    <el-dialog
      width="80%"
      title=""
      :visible.sync="nuledModalVisible"
      append-to-body
    >
      <div class="text-center">
        <img :src="icoNotifyDanger" alt="" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea anular la liquidación?
        </h4>
        <p class="text-color-primary">
          Para completar el proceso de anulación debe ser anulada en el
          <LinkSRI />
        </p>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="nuledModalVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent title="Anular" @onSaveClick="onNuled" />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="200"
      title=""
      :visible.sync="deleteModalVisible"
      append-to-body
    >
      <div class="text-center">
        <img :src="icoNotifyDanger" alt="" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea eliminar la liquidación?
        </h4>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="deleteModalVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent title="Eliminar" @onSaveClick="onDelete" />
        </div>
      </div>
    </el-dialog>

    <WrapperSendDocumentDrawer
      @onDocumentSend="onDocumentSend"
      @onCloseDrawer="visibleDocumentSend = false"
      :visibleDocumentSend="visibleDocumentSend"
      :toMails="toMails"
      :toPhone="toPhone"
      :clientId="
        liquidation && liquidation.client ? liquidation.client.id : null
      "
      :recipientName="
        liquidation && liquidation.client ? liquidation.client.name : ''
      "
      :messageableType="'liquidation'"
      :messageableId="id"
      :moduleType="'liquidation'"
      :draftKey="'draft-liquidation-' + id"
    />
  </div>
</template>

<style lang="scss" scoped>
.img-sm {
  width: 0.8rem !important;
}
</style>

<script>
import WrapperSendDocumentDrawer from "../../../../components/WrapperSendDocumentDrawer";
import liquidationService from "../services/liquidationService";
import IconMoreOptionComponent from "@/components/General/IconMoreOption";
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import LinkSRI from "@/components/General/LinkSRI";
import SigningConfirmModal from "@/components/General/SigningConfirmModal";
import { signingEventBus } from "@/services/signingEventBus";
import {
  icoNotifyDanger,
  iconEdit,
  iconDelete,
  iconNuled,
  iconSend,
  iconDownload,
  iconCheck,
  icoSignature,
  icoPreview
} from "@/services/resources";
import { downloadFile } from "@/assets/utils/files";

export default {
  name: "LiquidationOptionsByStatus",
  props: ["status", "id", "is_paid"],
  data() {
    return {
      icoNotifyDanger,
      iconEdit,
      iconDelete,
      iconNuled,
      iconSend,
      iconDownload,
      iconCheck,
      icoSignature,
      icoPreview,
      sriModalVisible: false,
      nuledModalVisible: false,
      deleteModalVisible: false,
      visibleDocumentSend: false,
      liquidation: null,
      toMails: [],
      toPhone: ""
    };
  },
  computed: {
    textOptionIsPaid() {
      return this.is_paid ? "Desmarcar" : "Marcar";
    }
  },
  methods: {
    async getLiquidation() {
      try {
        let response = await liquidationService.getLiquidationById(this.id);
        if (response) this.liquidation = response.data.data;
      } catch (e) {
        return false;
      }
    },
    async handleCommand(command) {
      if (!this.liquidation) {
        await this.getLiquidation();
        await this.$nextTick();
      }
      switch (command) {
        case "liquidation-view":
          this.$emit("goPage", "sales.liquidations.view", { id: this.id });
          break;
        case "liquidation-edit":
          this.$emit("goPage", "sales.liquidations.edit", { id: this.id });
          break;
        case "liquidation-signature":
          this.sriModalVisible = true;
          break;
        case "liquidation-nuled":
          this.nuledModalVisible = true;
          break;
        case "liquidation-delete":
          this.deleteModalVisible = true;
          break;
        case "liquidation-send":
          this.openSendDrawer();
          break;
        case "liquidation-download":
          this.download();
          break;
        case "liquidation-paid":
          this.togglePaid();
          break;
      }
    },
    async sendSRI() {
      const docId = this.liquidation.id;
      const clientName = this.liquidation.client
        ? this.liquidation.client.name
        : "";
      const documentNumber = this.liquidation.number_liquidation || "";

      this.sriModalVisible = false;
      signingEventBus.$emit("signing:start", {
        id: docId,
        clientName,
        documentNumber
      });
      this.$emit("onSigningStart", docId);

      try {
        let response = await liquidationService.sendLiquidationSRI({
          user_business_liquidation_id: docId
        });
        const { success, message, data } = response.data;
        if (success) {
          signingEventBus.$emit("signing:done", {
            id: docId,
            clientName,
            documentNumber
          });
          this.liquidation = data;
          this.$emit("onSigningDone", { id: docId, data });
        } else {
          signingEventBus.$emit("signing:error", {
            id: docId,
            message: message || "Error al firmar"
          });
          this.$emit("onSigningError", docId);
        }
      } catch (error) {
        signingEventBus.$emit("signing:error", {
          id: docId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al firmar"
        });
        this.$emit("onSigningError", docId);
      }
    },
    async onNuled() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const docId = this.liquidation.id;
        let response = await liquidationService
          .updateLiquidationStatus({ user_business_liquidation_id: docId })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.nuledModalVisible = false;
          });
        const { success, message, data } = response.data;
        if (success) {
          this.liquidation = data;
          this.$notifications.success({ message });
          this.$emit("onSigningDone", { id: docId, data });
        }
      } catch (e) {
        return false;
      }
    },
    async onDelete() {
      try {
        const docId = this.liquidation.id;
        let response = await liquidationService
          .deleteLiquidationById(docId)
          .finally(() => {
            this.deleteModalVisible = false;
          });
        const { success, message } = response.data;
        if (success) {
          this.$notifications.success({ message });
          this.$emit("onDocDeleted", docId);
        }
      } catch (e) {
        return false;
      }
    },
    async download() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const { number_liquidation, id } = this.liquidation;
        let response = await liquidationService
          .liquidationDownloadPdf({ id })
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        if (response.data)
          downloadFile(response.data, `Liquidacion - #${number_liquidation}`);
      } catch (e) {
        return false;
      }
    },
    async togglePaid() {
      try {
        const { is_paid, id } = this.liquidation;
        let response = await liquidationService.updateLiquidationStatus({
          user_business_liquidation_id: id,
          is_paid: !is_paid
        });
        const { success, message, data } = response.data;
        if (success) {
          this.liquidation = data;
          this.$notifications.success({ message });
          this.$emit("onSigningDone", { id, data });
        }
      } catch (e) {
        return false;
      }
    },
    openSendDrawer() {
      const client = this.liquidation?.client;
      this.toMails = client && client.email ? [client.email] : [];
      this.toPhone = client && client.phone ? String(client.phone).trim() : "";
      this.visibleDocumentSend = true;
    },
    async onDocumentSend({ data }) {
      data.append("liquidation_id", this.liquidation.id);

      const emailId = `email-liquidation-${Date.now()}`;
      const clientName = this.liquidation?.client?.name || "";
      const docNumber = this.liquidation?.number_liquidation || "";

      this.visibleDocumentSend = false;

      signingEventBus.$emit("email:start", {
        id: emailId,
        clientName,
        documentNumber: `Liquidación #${docNumber}`
      });

      try {
        let response = await liquidationService.sendLiquidationEmail({ data });
        const { success, message } = response.data;
        if (success) {
          signingEventBus.$emit("email:done", {
            id: emailId,
            clientName,
            documentNumber: `Liquidación #${docNumber}`
          });
        } else {
          signingEventBus.$emit("email:error", {
            id: emailId,
            message: message || "Error al enviar el documento"
          });
        }
      } catch (error) {
        signingEventBus.$emit("email:error", {
          id: emailId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al enviar"
        });
      }
    }
  },
  components: {
    IconMoreOptionComponent,
    ButtonPrimaryComponent,
    WrapperSendDocumentDrawer,
    LinkSRI,
    SigningConfirmModal
  }
};
</script>
